import { render, staticRenderFns } from "./WebMailListSideItem.vue?vue&type=template&id=39a4c1ac&scoped=true&"
import script from "./WebMailListSideItem.vue?vue&type=script&lang=ts&"
export * from "./WebMailListSideItem.vue?vue&type=script&lang=ts&"
import style0 from "./WebMailListSideItem.vue?vue&type=style&index=0&id=39a4c1ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a4c1ac",
  null
  
)

export default component.exports